import byIdNormal from "./byId.normal";
import byIdReadonly from "./byId.readonly";

let byId = null;
//#!if readonly !== true
// byId = byIdNormal;
//#!else
byId = byIdReadonly;
//#!endif

export default byId;
